<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>staking配置</el-breadcrumb-item>
    </el-breadcrumb>
    <StakingSearchBar @add="add" @search="search" />

    <el-card class="page-content">
      <!-- v-loading="status.isFetching" -->
      <el-table
        :data="tableData"
        size="small"
        highlight-current-row
        style="width: 100%"
        ref="tableList"
        row-key="id"
      >
        <el-table-column label="排序" width="80">
          <template #default="scope">
            <span v-if="scope.row.isDisplay">{{ scope.row.sort }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="coinType"
          label="币种"
          min-width="100"
        ></el-table-column>
        <el-table-column
          property="scale"
          label="精度"
          min-width="100"
          sortable
          :sort-method="(row1, row2) => sortChange('scale', row1, row2)"
        ></el-table-column>
        <el-table-column
          property="defaultPrice"
          label="默认价格"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="总共收益"
          min-width="150"
          sortable
          :sort-method="(row1, row2) => sortChange('totalIncome', row1, row2)"
        >
          <template #default="scope">
            {{ thousandSeparator(scope.row.totalIncome) }}
          </template>
        </el-table-column>
        <el-table-column label="质押币种（实时年化）" width="300">
          <template #default="scope">
            <el-tag v-for="o in scope.row.defiList" :key="o.defiId" size="small"
              >{{ o.defiCoinType }}({{ o.yearChemicalRate }}%)</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="锁仓期限"
          min-width="100"
          sortable
          :sort-method="(row1, row2) => sortChange('day', row1, row2)"
        >
          <template #default="scope"> {{ scope.row.day }}天 </template>
        </el-table-column>
        <el-table-column label="已存入数量" min-width="400" ssortable>
          <template #default="scope">
            <div
              v-for="o in scope.row.defiList"
              :key="o.defiId"
              style="margin-bottom: 4px"
            >
              <el-tag size="small">
                {{ o.defiCoinType }}: ({{ o.nowFinancing }}/{{
                  o.allFinancing
                }})&nbsp;&nbsp; {{ numMul(o.usdtPrice, o.nowFinancing) }}/{{
                  numMul(o.usdtPrice, o.allFinancing)
                }}(USDT)
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="赎回中数量" min-width="400" ssortable>
          <template #default="scope">
            <div
              v-for="o in scope.row.defiList"
              :key="o.defiId"
              style="margin-bottom: 4px"
            >
              <el-tag size="small">
                {{ o.defiCoinType }}: ({{ o.inRedeem }})&nbsp;&nbsp;
                {{ numMul(o.usdtPrice, o.inRedeem) }}(USDT)
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="status"
          label="产品状态"
          width="100"
          sortable
          :sort-method="(row1, row2) => sortChange('status', row1, row2)"
        >
          <template #default="scope">
            <span v-if="scope.row.status === 0">预热中</span>
            <span v-else-if="scope.row.status === 1">进行中</span>
            <span v-else-if="scope.row.status === 4">已结束</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发布状态"
          width="100"
          sortable
          :sort-method="(row1, row2) => sortChange('isDisplay', row1, row2)"
        >
          <template #default="scope">
            <span v-if="scope.row.isDisplay === 0">隐藏</span>
            <span v-else-if="scope.row.isDisplay === 1">开启中</span>
          </template>
        </el-table-column>
        <el-table-column
          property="createTime"
          label="创建时间"
          width="180"
          sortable
          :sort-method="(row1, row2) => sortChange('createTime', row1, row2)"
        >
          <template #default="scope">
            <span>{{ dateFormat(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="系统认购" width="180">
          <template v-slot="scope">
            <div v-for="item in scope.row.defiList" :key="item.id">
              <el-tag size="small">{{ item.defiCoinType }}</el-tag>
              <el-switch
                v-if="[4].includes(scope.row.status)"
                :value="item.systemSwitch"
                disabled
              >
              </el-switch>
              <el-popconfirm
                v-else
                title="确定更改？"
                @confirm="systemSwitchChange(item.defiId, item.systemSwitch)"
              >
                <template #reference>
                  <el-switch :value="item.systemSwitch"> </el-switch>
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申赎开关" width="180">
          <template v-slot="scope">
            <el-popconfirm
              title="确定更改？"
              @confirm="outSwitchChange(scope.row.id, scope.row.outSwitch)"
            >
              <template #reference>
                <el-switch :value="scope.row.outSwitch"> </el-switch>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="250" align="center">
          <template #default="scope">
            <el-button
              type="text"
              size="medium"
              @click="editBtnClick(scope.row)"
              >修改</el-button
            >
            <el-popconfirm
              :title="`你确定${
                scope.row.isDisplay === 1 ? '隐藏' : '开启'
              }当前数据？`"
              @confirm="switchStatusBtnClick(scope.row)"
            >
              <template #reference>
                <el-button type="text" size="medium">
                  {{ scope.row.isDisplay === 1 ? '隐藏' : '开启' }}
                </el-button>
              </template>
            </el-popconfirm>

            <el-button
              :disabled="[0, 4].includes(scope.row.status)"
              type="text"
              size="medium"
              @click="buyBtnClick(scope.row)"
              >增加认购</el-button
            >
            <el-button
              type="text"
              size="medium"
              @click="buyHistoryBtnClick(scope.row)"
              >用户认购</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
    <AddProductModal
      :visible.sync="isShowAddStakingProductModal"
      :currentId="currentId"
      @success="getTableData"
      :isEdit="!!currentId"
    />
    <BuyHistoryModal
      :visible.sync="isShowBuyHistoryModal"
      type="currentTreasure"
      :currentId="currentId"
    />
    <AddBuyModal
      :visible.sync="isShowBuyModal"
      :currentId="currentId"
      @success="getTableData"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Pagination from 'components/pagination'
import {
  thousandSeparator,
  dateFormat,
  numMul,
  getTimeWithStartEnd,
} from '@/utils/encrypt.js'
import BuyHistoryModal from './components/BuyHistoryModal.vue'
import AddProductModal from './components/AddProductModal.vue'
import StakingSearchBar from './components/StakingSearchBar.vue'
import AddBuyModal from './components/AddStakingBuyModal.vue'
export default {
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
      },
      totalCount: 10,
      tableData: [],
      currentId: '',
      isShowAddStakingProductModal: false,
      isShowBuyHistoryModal: false,
      isShowBuyModal: false,
      searchOption: {
        isDisplay: '',
        status: '',
        coinType: '',
        period: [],
      },
    }
  },
  computed: {
    // ...mapState('bill', ['billList', 'pagination', 'totalCount']),
  },
  methods: {
    ...{ thousandSeparator, dateFormat, numMul },
    ...mapActions('financial', [
      'getStakingList',
      'setStakingOutSwitchOn',
      'setStakingOutSwitchOff',
      'setStakingSwitchOff',
      'setStakingSwitchOn',
      'setStakingStatusSet',
      'getCoinList',
    ]),
    resetpagination() {
      this.pagination = {
        page: 1,
        size: 10,
      }
    },
    pageChanged(pagination) {
      this.pagination = pagination
      this.getTableData()
    },
    successHandler() {},
    getSearchOption() {
      const { isDisplay, status, coinType, period } = this.searchOption
      const params = {
        isDisplay,
        status,
        coinType,
        ...this.pagination,
      }

      if (Array.isArray(period) && period.length === 2) {
        params.start = +getTimeWithStartEnd(period[0], 'start')
        params.end = +getTimeWithStartEnd(period[1], 'end')
      }

      return params
    },
    sortChange(key, row1, row2) {
      return row1[key] - row2[key]
    },
    getTableData() {
      if (this.currentId) {
        this.currentId = ''
      }
      const option = this.getSearchOption()

      this.getStakingList(option).then((res) => {
        console.log(res, '---')
        this.tableData = res.data.data
        this.totalCount = res.data.total
      })
    },
    add() {
      this.currentId = ''
      this.isShowAddStakingProductModal = true
    },
    search(formData) {
      this.resetpagination()
      Object.assign(this.searchOption, formData)
      this.getTableData()
    },
    editBtnClick(row) {
      this.currentId = row.id
      this.isShowAddStakingProductModal = true
    },
    buyHistoryBtnClick(row) {
      this.currentId = row.id
      this.isShowBuyHistoryModal = true
    },
    buyBtnClick(row) {
      this.currentId = row.id
      this.isShowBuyModal = true
    },
    switchStatusBtnClick(row) {
      const { isDisplay, id } = row
      this.setStakingStatusSet({
        id,
        status: isDisplay ? 0 : 1,
      }).then(() => {
        this.getTableData()
      })
    },
    systemSwitchChange(defiId, status) {
      let request = this.setStakingSwitchOn
      if (status) {
        request = this.setStakingSwitchOff
      }
      request({ defiId }).then(() => {
        this.getTableData()
      })
    },

    outSwitchChange(id, status) {
      let request = this.setStakingOutSwitchOn
      if (status) {
        request = this.setStakingOutSwitchOff
      }
      request({ id }).then(() => {
        this.getTableData()
      })
    },
  },
  components: {
    Pagination,
    AddProductModal,
    StakingSearchBar,
    BuyHistoryModal,
    AddBuyModal,
  },
  mounted() {
    this.getTableData()
    this.getCoinList()
  },
}
</script>
<style>
/* .textover {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
